





























































































import { Vue, Component } from "vue-property-decorator";
import algoliasearch, { SearchClient } from 'algoliasearch';
import { settings, Category, ICategoryShort } from '@/loader';

@Component({

})
export default class CategoriesMenu extends Vue {
	public categories: any[] = [];

	public toggle(c: ICategoryShort | null, parent?: ICategoryShort) {
		(parent?.childs || this.categories).forEach(x => { x.active = false; });
		if (c) {
			c.active = true;
		}
	}

	public get active() {
		return this.categories.find(c => c.active) || null;
	}

	public get url() {
		return (c: ICategoryShort) => `https://www.laboandco.com/${c.url_key}`;
	}

	public created() {
		let t = localStorage.getItem("categories");
		if (t) {
			let data = JSON.parse(t);
			let limit = new Date();
			limit.setDate(-1);
			if (data && new Date(data.date || "2999-01-01T00:00:00.000Z") > limit) {
				console.log("cached", data.categories);
				this.categories = data.categories;
				return;
			}
		}

		let client: SearchClient = algoliasearch(settings.algolia_aplication_id, settings.algolia_search_api_key);
		let index = client.initIndex(settings.algolia_categories_index);
		index.search<Category>("", {
			getRankingInfo: false,
			analytics: false,
			enableABTest: false,
			hitsPerPage: 1000,
			attributesToRetrieve: "*",
			facetFilters: [
				["main_seo_category:true"],
				["level:0"]
			],
		}).then(result => {
			// Create categories tree
			// let tmp: { [id: number]: ICategoryShort } = {};
			let main = result.hits
				// .filter(h => h.level === 0)
				.map(h => {
					let c: ICategoryShort = { childs: h.childs, url_key: h.url_key, id: h.id, name: h.name, active: false };
					// tmp[c.id] = c;
					return c;
				}).sort((a, b) => a.name.localeCompare(b.name));

			// result.hits
			// 	.filter(h => h.level > 0)
			// 	.forEach(h => {
			// 		let c: ICategoryShort = { childs: [], url_key: h.url_key, id: h.id, name: h.name, active: false };
			// 		tmp[c.id] = c;
			// 		if (h.parent?.id && tmp[h.parent.id]) {
			// 			tmp[h.parent.id].childs.push(c);
			// 		}
			// 	});

			main.forEach(m => {
				m.childs = m.childs
					// .filter(h => result.hits.find(x => x.id === h.id)?.main_seo_category || false)
					.sort((a, b) => a.name.localeCompare(b.name));
				m.childs.forEach(h => { h.active = false; });
				m.childs.forEach(c => {
					c.childs = c.childs
						// .filter(h => result.hits.find(x => x.id === h.id)?.main_seo_category || false)
						.sort((a, b) => a.name.localeCompare(b.name));
					c.childs.forEach(h => { h.active = false; });
				})
			});
			if (main.length) {
				main[0].active = true;
			}
			this.categories = main;
			console.log("parsed", main);
			localStorage.setItem("categories", JSON.stringify({ date: new Date(), categories: main }));
		});
	}
}
